import {  USERACTIVITES_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"




export const getAll = ({ commit },id) => {
    const url = USERACTIVITES_API.replace("{id}",id)
    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        commit(types.SET_ITEMS, data?.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE,data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, data)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_CURRENT_ITEM, null)

        commit(types.SET_MESSAGE, (err?.response?.data?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
      
    })
}

export const exportData = ({ commit },id) => {
    const url = USERACTIVITES_API.replace("{id}",id)+"&export=true"
    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
       
        const a = document.createElement("a")
        a.setAttribute("id","download_a_id")
        a.setAttribute("href",data.file_url)
        a.setAttribute("target","_blank")
        a.setAttribute("download","")
        a.click()
        document.appendChild(a)
        

    }).catch(() => {
     
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
      
    })
}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



